import { Accordion, AccordionTab } from "primereact/accordion"
import { Divider } from "primereact/divider";

function TeachingPage() {
	return (

		<div className="notes_content">
		<Accordion multiple activeIndex={[]}>
			<AccordionTab header="Algebraic Number Theory (Imperial College; 2020, 2021)">
				<div>
					Lecture notes for the&nbsp;
					<a href={require('../content/Notes_ANT_2020.pdf')} target='_blank' rel="noreferrer">2020</a>
					&nbsp;and &nbsp;
					<a href={require('../content/Notes_ANT_2021.pdf')} target='_blank' rel="noreferrer">2021</a>
					&nbsp;course, and some&nbsp;
					<a href={require('../content/Number_Theory_Problems.pdf')} target='_blank' rel="noreferrer">problems</a>
					. The main difference is that in 2020 (resp. 2021) I discussed higher reciprocity laws (resp. Diophantine approximation, in particular Thue's theorem) at the end of the course.
				</div>
			</AccordionTab>
			<AccordionTab header="Cohomology of coherent sheaves on schemes (Paris; 2025, 2026)">
				<div>
					<a href={require('../content/notes-cohqcoh26.pdf')} target='_blank' rel="noreferrer">Lecture notes</a>
				</div>
				{/* <div className="text-divider"/>
				<div>
					<ul>
						<li><a href={require('../content/TD 1 2026.pdf')} target='_blank' rel="noreferrer">TD 1</a></li>
						<li><a href={require('../content/TD 2 2026.pdf')} target='_blank' rel="noreferrer">TD 2</a></li>
						<li><a href={require('../content/TD 3 2026.pdf')} target='_blank' rel="noreferrer">TD 3</a></li>
						<li><a href={require('../content/TD 4 2026.pdf')} target='_blank' rel="noreferrer">TD 4</a></li>
						<li><a href={require('../content/TD 5 2026.pdf')} target='_blank' rel="noreferrer">TD 5</a></li>
						<li><a href={require('../content/TD 6 2026.pdf')} target='_blank' rel="noreferrer">TD 6</a></li>
					</ul>
				</div>
				<div className="text-divider"/>
				<div>
					<a href={require('../content/Examen qcoh 2025.pdf')} target='_blank' rel="noreferrer">Exam 02-2025</a>
				</div> */}
			</AccordionTab>
			{/* <AccordionTab header="Représentations des groupes finis">
				<p>
					<a href={require('../content/Rep-TD1.pdf')} target='_blank' rel="noreferrer">TD1</a>,&nbsp;
					<a href={require('../content/Rep-TD2.pdf')} target='_blank' rel="noreferrer">TD2</a>,&nbsp;
					<a href={require('../content/Rep-TD3.pdf')} target='_blank' rel="noreferrer">TD3</a>
				</p>
			</AccordionTab> */}
		</Accordion>
	</div>

	);
}

export default TeachingPage;